<script>
    import {onMount} from "svelte";
    import gsap from 'gsap';
    import {labels, mainTimeline} from "../../timelines/main-timeline";
    import {createEventDispatcher} from 'svelte';

    export let scene = 0;

    const dispatch = createEventDispatcher();

    function dispatchSceneSelection(scene) {
        return function () {
            dispatch('go-to-scene', {
                scene,
            });
        }
    }

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();

    const {customerJourneyStart, customerJourneyEnd} = labels;

    const transition = {
        opacity: 0,
        duration: 1.5,
    }

    onMount(() => {
        inTimeline.from('.journey-label-container', transition);
        outTimeline.to('.journey-label-container', transition);
    })

    mainTimeline.add(inTimeline, customerJourneyStart);
    mainTimeline.add(outTimeline, customerJourneyEnd + '+=1.6');

    $: showLabels = scene === 12;

</script>

<svg xmlns="http://www.w3.org/2000/svg" width="1148" height="485" viewBox="0 0 1148 485" overflow="visible">
    <g class="journey-label-container" transform="translate(397 443)">
        {#if showLabels}
            <g on:click={dispatchSceneSelection(6)} class="link">
                <rect fill="rgba(0,0,0,0)" transform="translate(0 281)" width="320" height="60" x="100" y="23"></rect>
                <text id="STEP_3_Assemble_the_buyer_team" data-name="STEP 3
    Assemble the buyer team" transform="translate(0 281)" fill="#f83" font-size="24"
                      font-family="Metric-Regular, Metric">
                    <tspan x="166.012" y="23">STEP 3</tspan>
                    <tspan fill="#fff">
                        <tspan x="0" y="49">Assemble the buyer team</tspan>
                    </tspan>
                </text>
            </g>
            <g on:click={dispatchSceneSelection(9)} class="link">
                <rect fill="rgba(0,0,0,0)" width="320" height="60" x="0" y="0" transform="translate(800 281)"></rect>
                <text id="STEP_6_Evaluate_their_capabilities" data-name="STEP 6
    Evaluate their capabilities" transform="translate(916 281)" fill="#f83" font-size="24"
                      font-family="Metric-Regular, Metric">
                    <tspan x="0" y="23">STEP 6</tspan>
                    <tspan fill="#fff">
                        <tspan x="0" y="49">Evaluate their capabilities</tspan>
                    </tspan>
                </text>
            </g>
            <g on:click={dispatchSceneSelection(5)} class="link">
                <rect fill="rgba(0,0,0,0)" width="320" height="60" x="100" y="0" transform="translate(0 135)"></rect>
                <text id="STEP_2_Learn_what_s_out_there" data-name="STEP 2
    Learn what’s out there" transform="translate(0 135)" fill="#f83" font-size="24"
                      font-family="Metric-Regular, Metric">
                    <tspan x="165.836" y="23">STEP 2</tspan>
                    <tspan fill="#fff">
                        <tspan x="26.102" y="49">Learn what’s out there</tspan>
                    </tspan>
                </text>
            </g>
            <g on:click={dispatchSceneSelection(10)} class="link">
                <rect fill="rgba(0,0,0,0)" width="320" height="60" x="0" y="0" transform="translate(800 135)"></rect>
                <text id="STEP_7_Apply_the_trust_test" data-name="STEP 7
Apply the trust test" transform="translate(916 135)" fill="#f83" font-size="24" font-family="Metric-Regular, Metric">
                    <tspan x="0" y="23">STEP 7</tspan>
                    <tspan fill="#fff">
                        <tspan x="0" y="49">Apply the trust test</tspan>
                    </tspan>
                </text>
            </g>
            <g on:click={dispatchSceneSelection(7)} class="link">
                <rect fill="rgba(0,0,0,0)" width="320" height="60" x="70" y="10" transform="translate(109 416)"></rect>
                <text id="STEP_4_Overcome_the_obstacles" data-name="STEP 4
Overcome the obstacles" transform="translate(109 416)" fill="#f83" font-size="24" font-family="Metric-Regular, Metric">
                    <tspan x="164.301" y="23">STEP 4</tspan>
                    <tspan fill="#fff">
                        <tspan x="11.98" y="49">Overcome the obstacles</tspan>
                    </tspan>
                </text>
            </g>
            <g on:click={dispatchSceneSelection(8)} class="link">
                <rect fill="rgba(0,0,0,0)" width="320" height="60" x="0" y="0" transform="translate(700 416)"></rect>
                <text id="STEP_5_Shortlist_potential_partners" data-name="STEP 5
Shortlist potential partners" transform="translate(808 416)" fill="#f83" font-size="24"
                      font-family="Metric-Regular, Metric">
                    <tspan x="0" y="23">STEP 5</tspan>
                    <tspan fill="#fff">
                        <tspan x="0" y="49">Shortlist potential partners</tspan>
                    </tspan>
                </text>
            </g>
            <g on:click={dispatchSceneSelection(4)} class="link">
                <rect fill="rgba(0,0,0,0)" width="320" height="60" x="168.602" y="23" transform="translate(109)"></rect>
                <text id="STEP_1_Start_the_search" data-name="STEP 1
Start the search" transform="translate(109)" fill="#f83" font-size="24" font-family="Metric-Regular, Metric">
                    <tspan x="168.602" y="23">STEP 1</tspan>
                    <tspan fill="#fff">
                        <tspan x="86.523" y="49">Start the search</tspan>
                    </tspan>
                </text>
            </g>
            <g on:click={dispatchSceneSelection(11)} class="link">
                <rect fill="rgba(0,0,0,0)" width="320" height="60" x="0" y="23" transform="translate(700)"></rect>
                <text id="STEP_8_Pick_a_winner" data-name="STEP 8
Pick a winner" transform="translate(808)" fill="#f83" font-size="24" font-family="Metric-Regular, Metric">
                    <tspan x="0" y="23">STEP 8</tspan>
                    <tspan fill="#fff">
                        <tspan x="0" y="49">Pick a winner</tspan>
                    </tspan>
                </text>
            </g>
        {/if}
    </g>
</svg>

<style>
    .link {
        cursor: pointer;
    }
</style>
